import { Grid } from '@material-ui/core';
import { useFormikContext, Field } from 'formik';
import React, { useState, useCallback } from 'react';
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { ICard } from './index';
import type { Focused } from 'react-credit-cards';

const NewCard = () => {
  const [currentField, setCurrentField] = useState<Focused>('number');

  const { values, handleBlur } = useFormikContext<ICard>();

  const onFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    const field = e.target.name as Focused;
    setCurrentField(field);
  }, []);

  const onBlurCvc = useCallback(
    (e) => {
      setCurrentField('name');
      handleBlur(e);
    },
    [handleBlur]
  );

  return (
    <>
      <>
        <Grid spacing={2} container>
          <Grid item xs={12} md={6}>
            <Cards
              focused={currentField}
              cvc={values.cvc}
              expiry={values.expiry}
              name={values.name}
              number={values.number}
              locale={{ valid: 'Validade' }}
              placeholders={{ name: 'SEU NOME AQUI' }}
            />
          </Grid>
          <Grid container spacing={2} xs={12} md={6}>
            <Grid item xs={12}>
              <Field
                id='number'
                name='number'
                component={TextFormField}
                fullWidth
                label='Número do cartão'
                placeholder='Insira o número do cartão'
                mask='creditcard'
                onFocus={onFocus}
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                id='name'
                name='name'
                component={TextFormField}
                fullWidth
                label='Nome impresso no cartão'
                placeholder='Insira o nome igual do cartão'
                onFocus={onFocus}
                mask={'onlylettersandspace'}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                id='expiry'
                name='expiry'
                component={TextFormField}
                fullWidth
                label='Data de expiração'
                placeholder='Insira a data de expiração do cartão Mês/Ano'
                onFocus={onFocus}
                inputProps={{
                  inputMode: 'numeric',
                  placeholder: 'MM/AA',
                }}
                mask={'expirydate'}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Field
                id='cvc'
                name='cvc'
                component={TextFormField}
                fullWidth
                label='Código de segurança'
                placeholder='Insira o CVV do cartão'
                onFocus={onFocus}
                onBlur={onBlurCvc}
                inputProps={{
                  maxLength: 4,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    </>
  );
};
export default NewCard;
